import type { IServiceInterval } from "./IServiceInterval";
import type { IServiceSchedule, IServiceScheduleDto } from "./IServiceSchedule";

import { ServiceInterval } from "./ServiceInterval";
import { ServiceIntervalState } from "./ServiceIntervalState";

export class ServiceSchedule implements IServiceSchedule
{

    serviceScheduleId: string;
    intervals: IServiceInterval[];
    nextInterval?: IServiceInterval;

    constructor( model: IServiceScheduleDto )
    {
        this.serviceScheduleId = model.serviceScheduleId;
        this.intervals = model.intervals.map( i => new ServiceInterval( i, model.serviceScheduleId ) );
        this.nextInterval = this.intervals.find( i => i.serviceIntervalId == model.nextInterval?.serviceIntervalId );
    }

    /**
     * Gets the next service interval for the given vehicle
     * @param vehicle 
     */
    getNextIntervalForOdometer( odometer: number )
    {

        let i = this.intervals.length;
        let nextInterval: IServiceInterval | null = this.intervals[ 0 ];

        while( i-- )
        {
            const interval = this.intervals[ i ];
            if( interval.state != ServiceIntervalState.NotDone ) return nextInterval;
            if( interval.km < odometer ) return nextInterval;
            nextInterval = interval;
        }

        return this.intervals[ 0 ];
        
    }

}